import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a617553"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contain"
};
const _hoisted_2 = {
  class: "login"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "欢迎登录", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "手机号：", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "密码：", -1));
const _hoisted_7 = {
  class: "tip"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "没有账号密码？", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "手机号：", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "验证码：", -1));
const _hoisted_11 = {
  class: "tip"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "有账号密码？", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "设置密码：", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "用户名：", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "电子邮箱：", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "所在行业：", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "公司名称：", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_custom = _resolveComponent("header-custom");
  const _component_router_view = _resolveComponent("router-view");
  const _component_footer_custom = _resolveComponent("footer-custom");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_header_custom), _createElementVNode("div", _hoisted_1, [_createVNode(_component_router_view)]), _createVNode(_component_footer_custom), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "close",
    onClick: _cache[0] || (_cache[0] = $event => $setup.store.isOpenLoginModal = false)
  }, "关闭"), _createElementVNode("div", _hoisted_3, [_hoisted_4, !$setup.isPhoneLogin && !$setup.isSetPassword ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_5, _createVNode(_component_el_input, {
    modelValue: _ctx.login.userCode,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.login.userCode = $event),
    size: "large"
  }, null, 8, ["modelValue"]), _hoisted_6, _createVNode(_component_el_input, {
    modelValue: _ctx.login.userPassword,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.login.userPassword = $event),
    type: "password",
    size: "large"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
    class: "login-btn",
    size: "large",
    type: "primary",
    onClick: $setup.loginHandle
  }, {
    default: _withCtx(() => [_createTextVNode("登录")]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", {
    style: {
      "color": "#007aff",
      "cursor": "pointer"
    },
    onClick: _cache[3] || (_cache[3] = $event => $setup.isPhoneLogin = true)
  }, "请创建账号")])], 64)) : _createCommentVNode("", true), $setup.isPhoneLogin && !$setup.isSetPassword ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_9, _createVNode(_component_el_input, {
    modelValue: _ctx.register.userCode,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.register.userCode = $event),
    size: "large",
    style: {
      "width": "50%"
    }
  }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("span", {
    class: "get-code-btn",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.getCode && $setup.getCode(...args))
  }, "获取验证码", 512), [[_vShow, $setup.timeOut === 60]]), _withDirectives(_createElementVNode("span", {
    style: {
      "font-size": "13px",
      "margin-left": "10px"
    }
  }, _toDisplayString($setup.timeOut) + "s后，可重新获取验证码", 513), [[_vShow, $setup.timeOut !== 60]]), _hoisted_10, _createVNode(_component_el_input, {
    modelValue: _ctx.register.code,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.register.code = $event),
    size: "large"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
    class: "login-btn",
    size: "large",
    type: "primary",
    onClick: $setup.registerHandle
  }, {
    default: _withCtx(() => [_createTextVNode("确认")]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", {
    style: {
      "color": "#007aff",
      "cursor": "pointer"
    },
    onClick: _cache[7] || (_cache[7] = $event => $setup.isPhoneLogin = false)
  }, "请登录")])], 64)) : _createCommentVNode("", true), $setup.isSetPassword && $setup.isPhoneLogin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_hoisted_13, _createVNode(_component_el_input, {
    modelValue: _ctx.newPassword,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.newPassword = $event),
    type: "password",
    size: "large",
    placeholder: "请输入6-20位字母、数字、特殊字符组合密码"
  }, null, 8, ["modelValue"]), _hoisted_14, _createVNode(_component_el_input, {
    modelValue: _ctx.userName,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.userName = $event),
    size: "large"
  }, null, 8, ["modelValue"]), _hoisted_15, _createVNode(_component_el_input, {
    modelValue: _ctx.userEmail,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.userEmail = $event),
    size: "large"
  }, null, 8, ["modelValue"]), _hoisted_16, _createVNode(_component_el_input, {
    modelValue: _ctx.industry,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.industry = $event),
    size: "large"
  }, null, 8, ["modelValue"]), _hoisted_17, _createVNode(_component_el_input, {
    modelValue: _ctx.companyName,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _ctx.companyName = $event),
    size: "large"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
    class: "login-btn",
    size: "large",
    type: "primary",
    onClick: $setup.setPassword
  }, {
    default: _withCtx(() => [_createTextVNode("确认")]),
    _: 1
  }, 8, ["onClick"])], 64)) : _createCommentVNode("", true)])], 512), [[_vShow, $setup.store.isOpenLoginModal]])], 64);
}